export default __webpack_public_path__ + "static/media/category6.436f2224.png";